import * as moment from 'moment-timezone';
import * as _ from 'lodash';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BreadcrumbsService } from '../../core/breadcrumbs.service';
import { ScrollService } from '../../core/scroll.service';
import { LangService } from '../../core/lang.service';
import { Subscription } from 'rxjs';
import { ChecklistStep, ChecklistStepRoute } from '../pnel-cts-checklist/model/checklist-steps';
import { IAccountType } from '../../constants/account-types';
import { LoginGuardService } from '../../api/login-guard.service';
import { MyTestSessionsSetupService, SORT_BY_DATETIMESTART, ILocation } from '../my-test-sessions-setup.service';
import { _SAMPLE_INVITATION_CODES } from '../../constants/fakeinvitations/codes';
import { applySecretKeyMask } from '../../core/secret-key-mask';
import { RoutesService } from '../../api/routes.service';

let SAMPLE_INVITATION_CODES = _SAMPLE_INVITATION_CODES;
const getInvitCode = () => {
  const i = Math.floor(SAMPLE_INVITATION_CODES.length * Math.random());
  const str = SAMPLE_INVITATION_CODES[i];
  if (SAMPLE_INVITATION_CODES.length === 0){
    SAMPLE_INVITATION_CODES = _SAMPLE_INVITATION_CODES;
  }
  SAMPLE_INVITATION_CODES.splice(i, 1);
  return applySecretKeyMask(str);
}


interface ISession {
  m?:moment.Moment,
  sessionNum:number,
  room: string,
  campusBuilding: string,
  capacity: number,
  locationNumber: number,
  dateTimeStart: string,
  hasAccessCode: boolean, 
  accessCode: string, 
  isHidden: boolean, 
  sessionInvitationCode: string,
}
@Component({
  selector: 'view-cts-invitiations',
  templateUrl: './view-cts-invitiations.component.html',
  styleUrls: ['./view-cts-invitiations.component.scss']
})
export class ViewCtsInvitiationsComponent implements OnInit {

  public breadcrumb = [];
  public setupId:string;
  public isLoaded:boolean;
  public isLoadFailed:boolean;
  public sessions:ISession[] = [];

  private locations:Map<number, ILocation>;
  private mySetupSub:Subscription;
  private routeSub:Subscription;

  constructor(
    private loginGuard: LoginGuardService, // 
    private breadcrumbsService: BreadcrumbsService,
    private router:Router,
    private route:ActivatedRoute,
    private scrollService:ScrollService,
    private lang:LangService,
    private routes: RoutesService,
    private mySetup:MyTestSessionsSetupService,
  ) { }
  
  ngOnInit() {
    this.loginGuard.activate([IAccountType.TEST_ADMIN]);
    this.scrollService.scrollToTop();
    this.routeSub = this.route.params.subscribe(routeParams => {
      this.setupId = routeParams['setupId'];
      this.breadcrumb = this.mySetup.generateBreadcrumbs(this.setupId, 'cts_invitations_title');
      this.initRouteView();
    });
  }

  initRouteView(){
    let isInitialized = false;
    this.mySetupSub = this.mySetup.sub().subscribe(setupInfo => {
      if (setupInfo && !isInitialized){
        isInitialized = true;
        this.initLocations().then( ()=> {
          return this.initLocationTimeSlots();
        })
      }
    })
  }

  initLocations(){
    return this.mySetup
      .getLocations(<any>this.setupId)
      .then(locationsData => {
        this.locations = new Map()
        locationsData.forEach( (location, locationIndex) => {
          location.__number = locationIndex + 1;
          this.locations.set(location.id, location);
        })
      })
      .catch(e => {
        this.isLoadFailed = true;
      })
  }
  
  initLocationTimeSlots(){
    this.isLoaded = true;
    const setupId = parseInt(this.setupId);
    this.mySetup
      .getTimeSlots(setupId)
      .then( timeSlots => {
        // console.log('initLocationTimeSlots')
        timeSlots = timeSlots.sort(SORT_BY_DATETIMESTART);
        this.sessions = [];
        timeSlots.forEach( (timeSlot, timeSlotIndex) => {
          const m = moment(timeSlot.dateTimeStart);
          const loc = this.locations.get(timeSlot.locationId);
          const session:ISession = {
            m, 
            sessionNum: timeSlotIndex + 1,
            room: loc.room,
            campusBuilding: loc.campusBuilding,
            capacity: loc.capacity,
            locationNumber: loc.__number,
            dateTimeStart: m.format('MMM. D') +' '+ this.lang.tra('time_at') +' '+ m.format('HH:mma'),
            hasAccessCode: timeSlot.isAccessCodeProtected, 
            accessCode: timeSlot.accessCode, 
            isHidden: timeSlot.isHidden, 
            sessionInvitationCode: getInvitCode(),
          }
          this.sessions.push(session);
        })
      });
  }

  renderInvitationLink(invitationCode:string){
    return [
      this.routes.currentHost(),
      this.lang.c(),
      IAccountType.TEST_TAKER,
      'booking',
      'invite',
      invitationCode
    ].join('/')
  }

  getCurrentStepId(){
    return ChecklistStep.SendInvitations
  }

  isSessionsReleased(){
    return this.mySetup.isSessionsReleased();
  }

  gotoNextRoute(){
    let breadcrumb = this.breadcrumbsService.TESTADMIN_DASHBOARD();
    this.router.navigate([ breadcrumb.route ]);
  }

}
